import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import HomePage from "@/pages/HomePage";
import PhilosophyPage from "@/pages/PhilosophyPage";
import AboutPage from "@/pages/AboutPage";
import CuratorialPage from "@/pages/CuratorialPage";
import GalleryPage from "@/pages/GalleryPage";
import ArtworkDetailPage from "@/pages/ArtworkDetailPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <SiteNav />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/philosophy" element={<PhilosophyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/curatorial" element={<CuratorialPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/:slug" element={<ArtworkDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </div>
        <SiteFooter />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
